import { render, staticRenderFns } from "./stepSupply.vue?vue&type=template&id=645a16ae&scoped=true&"
import script from "./stepSupply.vue?vue&type=script&lang=ts&"
export * from "./stepSupply.vue?vue&type=script&lang=ts&"
import style0 from "./stepSupply.vue?vue&type=style&index=0&id=645a16ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a16ae",
  null
  
)

export default component.exports